import { ITestableComponentProps } from "../../shared/types/testing.types";

export interface IAdminPanelProps extends ITestableComponentProps {
  title?: string;
}

export interface IDroppedPinListProps extends ITestableComponentProps {
  title?: string;
}

export const DefaultAdminPanelProps = {
  title: undefined,
};

export const DefaultDroppedPinListProps = {
  title: "Dropped Pin List",
};
